import React from 'react';
import { Shield, FileText, Clock, Lock } from 'lucide-react';
export default function TrustSection() {
  return <section className="py-16 bg-gray-50" data-id="element-261" data-mp="6pmf8vbedplv">
      <div className="container mx-auto px-4" data-id="element-262" data-mp="6qo0ttq1huhu">
        <h2 className="text-3xl font-serif font-bold text-primary text-center mb-12" data-id="element-263" data-mp="1x321zgmgwhl">
          Why Legal Professionals Trust Medicolegal Psychiatry
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-264" data-mp="3p2klfjys9eoh">
          {/* Robust & Objective */}
          <div className="bg-white p-6 rounded-lg shadow-md border-t-4 border-primary" data-id="element-265" data-mp="3k3r9hvz59vqf">
            <div className="text-primary mb-4" data-id="element-266" data-mp="3f4ehkwtf1ygz">
              <Shield className="h-10 w-10" data-id="element-267" data-mp="3f5683t85p60e" />
            </div>
            <h3 className="text-xl font-serif font-bold text-primary mb-2" data-id="element-268" data-mp="3a5tij0pwhku4">
              Robust & Objective
            </h3>
            <p className="text-slate" data-id="element-269" data-mp="1dbyo46hlm086">
              Evidence-based, impartial reports, defensible in court. Our
              reports are built on a foundation of sound clinical practice and
              objective evidence.
            </p>
          </div>
          {/* Clear & Concise */}
          <div className="bg-white p-6 rounded-lg shadow-md border-t-4 border-primary" data-id="element-270" data-mp="3d9a9a23frgf6">
            <div className="text-primary mb-4" data-id="element-271" data-mp="2ybrmv6e8dfaw">
              <FileText className="h-10 w-10" data-id="element-272" data-mp="2yd2r17bl8p2j" />
            </div>
            <h3 className="text-xl font-serif font-bold text-primary mb-2" data-id="element-273" data-mp="33b47rlljkcau">
              Clear & Concise
            </h3>
            <p className="text-slate" data-id="element-274" data-mp="3r0fdlhhr0wvu">
              Complex psychiatric issues translated into accessible language.
              Every report directly addresses the legal questions posed,
              avoiding unnecessary jargon.
            </p>
          </div>
          {/* Timely & Responsive */}
          <div className="bg-white p-6 rounded-lg shadow-md border-t-4 border-primary" data-id="element-275" data-mp="3m745ld17aa2c">
            <div className="text-primary mb-4" data-id="element-276" data-mp="drkg8p3nhbsk">
              <Clock className="h-10 w-10" data-id="element-277" data-mp="ijkac0x1hah8" />
            </div>
            <h3 className="text-xl font-serif font-bold text-primary mb-2" data-id="element-278" data-mp="il54vqjcstf3">
              Timely & Responsive
            </h3>
            <p className="text-slate" data-id="element-279" data-mp="ngpxzh1zwu29">
              Reports delivered within 10 working days, expedited options
              available. We are committed to meeting deadlines with prompt and
              efficient service.
            </p>
          </div>
          {/* Ethical & Confidential */}
          <div className="bg-white p-6 rounded-lg shadow-md border-t-4 border-primary" data-id="element-280" data-mp="9gyckv95gbe8">
            <div className="text-primary mb-4" data-id="element-281" data-mp="9it1eknjknnl">
              <Lock className="h-10 w-10" data-id="element-282" data-mp="4p6wxfrj7q2v" />
            </div>
            <h3 className="text-xl font-serif font-bold text-primary mb-2" data-id="element-283" data-mp="3vwj4r46iyr64">
              Ethical & Confidential
            </h3>
            <p className="text-slate" data-id="element-284" data-mp="3rvqvwc1keoad">
              Strict adherence to professional and legal standards. We handle
              all cases with the utmost discretion and integrity.
            </p>
          </div>
        </div>
      </div>
    </section>;
}